import { withClientErrorPage } from '@sm/webassets';
import FourTenError from './FourTenError';

export default withClientErrorPage(FourTenError, { titularElementTag: 'h1', errorCode: 410 });
